module.exports = __webpack_public_path__ + "media/images/layout/nav_icon-5006a88a3d52c71c1ccdb1d753c0a42c.svg";